// extracted by mini-css-extract-plugin
module.exports = {"extendedIcon":"PhotoManager_extendedIcon__2gD8i","btnItem":"PhotoManager_btnItem__1IPE1"};